module.exports = __webpack_public_path__ + "img/badge-fastest-lead-pickup-bronze.3a74a3cc.png";